import { render, staticRenderFns } from "./customsFields.vue?vue&type=template&id=3c297cbc&"
import script from "./customsFields.vue?vue&type=script&lang=js&"
export * from "./customsFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports